import React from 'react';
import { Row, Col } from 'deltoid/core/Blocks/BootstrapContainers';
import Form from 'deltoid/core/Form';
import WhyTooltip from '@components/BaseComponents/WhyTooltip';
import clsx from 'clsx';
import withSizes from "react-sizes";

const FormFooter = ({
  btnProps,
  tooltipProps,
  isMobile,
}) => {
  const { heading, body } = tooltipProps || {};
  const { label, className: classNameProp, ...rest } = btnProps || {};
  const className = clsx(
    {
      'w-100': isMobile,
    },
    classNameProp,
  )
  return (
    <Row className={isMobile ? 'flex-column-reverse p-4 bg-light' : 'p-4 bg-light'} noGutters>
      <Col md={6} className={`align-self-center ${isMobile ? 'text-center' : ''}`}>
        {tooltipProps && <WhyTooltip heading={heading} body={body} isMobile={isMobile}/>}
      </Col>
      <Col md={6} className={isMobile ? 'text-center mb-1' : 'text-right'}>
        <Form.Button
          className={className}
          {...rest}
        >
          {label}
        </Form.Button>
      </Col>
    </Row>
  )
};
const mapSizesToProps = ({ width }) => ({
  isMobile: width < 768,
});

export default withSizes(mapSizesToProps)(FormFooter);
